import React from 'react';
import styles from './index.module.scss';

function DraggableImage({
  imageRef,
  src,
  currentIndex,
  zoom,
  rotate,
  position,
  isDragging,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onLoad,
  disableCrop,
}) {
  return (
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */
    <div
      className={styles.cropImage__imageContainer}
      style={disableCrop ? { height: '100%' } : { height: '500px' }}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseUp}
    >
      <img
        key={currentIndex}
        alt="crop"
        ref={imageRef}
        src={src}
        onLoad={onLoad}
        className={isDragging ? styles.cropImage__imageContainer__dragging : ''}
        style={{
          transform: `translate(${position.x}px, ${position.y}px) scale(${zoom}) rotate(${rotate}deg)`,
          transformOrigin: 'center center',
          userSelect: 'none',
        }}
      />
    </div>
  );
}

export default DraggableImage;
